module.exports = __webpack_public_path__ + "static/media/2015_conf_Design_for_Enterprise_Processes.ee829607.png";